(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('mfXlsConfirm', mfXlsConfirm);

  function mfXlsConfirm() {

    function naner(v) {
      v = parseInt(v);
      return isNaN(v) ? 0 : v;
    }

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        var delayedResize = null;
        var doResize = _.throttle(function () {

          var foot = $('#xlsFooter');
          var elem = $('#xls-confirm-grid');

          var elemExtent = elem.offset().top + elem.outerHeight();
          var footTop = foot.offset().top;

          elemExtent += Math.max(naner(elem.css('margin-bottom')), naner(foot.css('margin-top')));
          var deltaY = footTop - elemExtent - 1;

          if (deltaY) {
            var h = naner(elem.css('height'));
            h += deltaY;
            elem.css('height', h);
            clearTimeout(delayedResize);
            delayedResize = setTimeout(doResize, 150);

          } else {
            $('#grid').trigger('resize.slickgrid');
          }


        }, 100);

        scope.$on('resized', function () {
          doResize();
        });
      }
    }
  }

})();
